import React, { useState } from 'react';
import { authApi } from '../services/api';
import { useAuth } from '../contexts/CockpitAuthContext';

import Icone from './Icone';
/**
 * TrocaSenhaModal — overlay obrigatorio quando usuario tem precisa_trocar_senha=1.
 * Sprint 5.8 (2026-05-24). Aplicado pros 3 novos usuarios criados com senha
 * default "123456" (Bruno, Lucas, Janaina).
 *
 * Render aparece em cima da Layout, sem opcao de fechar — bloqueia uso ate trocar.
 */
export default function TrocaSenhaModal() {
  const { usuario, setUsuario } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState('');
  const [senhaNova, setSenhaNova] = useState('');
  const [confirma, setConfirma] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  if (!usuario || !usuario.precisa_trocar_senha) return null;

  const submit = async (e) => {
    e.preventDefault();
    setErro('');
    if (!senhaAtual) return setErro('Informe a senha atual (a temporária que você recebeu)');
    if (senhaNova.length < 6) return setErro('Mínimo 6 caracteres');
    if (senhaNova === senhaAtual) return setErro('A nova senha precisa ser diferente da atual');
    if (senhaNova !== confirma) return setErro('Senhas não conferem');
    if (['123456', 'admin123', 'senha123', '12345678'].includes(senhaNova)) {
      return setErro('Senha muito comum. Escolha outra.');
    }
    setEnviando(true);
    try {
      const { data } = await authApi.trocarSenha(senhaAtual, senhaNova);
      // A senha nova encerra as outras sessões; esta segue com o token novo.
      if (data && data.token) localStorage.setItem('token', data.token);
      // Atualiza estado local — flag some, libera o cockpit
      const novoUsuario = { ...usuario, precisa_trocar_senha: false };
      localStorage.setItem('usuario', JSON.stringify(novoUsuario));
      if (setUsuario) setUsuario(novoUsuario);
      // Reload garante que tudo carrega limpo
      window.location.reload();
    } catch (err) {
      setErro(err.response?.data?.erro || err.message);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(10, 14, 26, 0.85)',
        backdropFilter: 'blur(12px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        className="card glass-strong"
        style={{
          maxWidth: 440,
          width: '100%',
          padding: 32,
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 36, marginBottom: 12 }}><Icone nome="cadeado" tamanho={30} espessura={1.5} /></div>
        <h2 style={{ margin: '0 0 8px', fontSize: 22 }}>Defina sua senha</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 24 }}>
          Olá, <strong>{usuario.nome}</strong>! Seu acesso foi criado com uma senha temporária.
          <br />Pra continuar, defina uma senha pessoal segura.
        </p>

        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <input
            type="password"
            className="form-control"
            placeholder="Senha atual (a temporária)"
            value={senhaAtual}
            onChange={e => setSenhaAtual(e.target.value)}
            autoComplete="current-password"
            autoFocus
            required
          />
          <input
            type="password"
            className="form-control"
            placeholder="Nova senha (mín 6 caracteres)"
            value={senhaNova}
            onChange={e => setSenhaNova(e.target.value)}
            autoComplete="new-password"
            required
            minLength={6}
          />
          <input
            type="password"
            className="form-control"
            placeholder="Confirme a nova senha"
            value={confirma}
            onChange={e => setConfirma(e.target.value)}
            required
            minLength={6}
          />
          {erro && <div className="alert alert-danger" style={{ padding: 10, fontSize: 12 }}>{erro}</div>}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={enviando}
            style={{ marginTop: 4 }}
          >
            {enviando ? 'Salvando…' : 'Salvar e continuar'}
          </button>
        </form>

        <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 20 }}>
          Dica: use letras + números + símbolos. Não compartilhe.
        </p>
      </div>
    </div>
  );
}
